import styled from 'styled-components';
import {Label} from '@tickchak/react-share/app';
import {BGImageCenter, mobileMedia} from '../../../../globalVariables/GlobalVariables';
import {editPencil} from '../../../../assets/symbols/symbols/Symbols.css';
import {windowBase} from '../../style.css';
import {getColor} from '../../utils/themeUtils';
import {dFlexCenter, dFlexColumnCenter} from '../../../../globalVariables/GlobalFlex';

export const profile = styled.div`
    ${windowBase};
    position: relative;
    grid-area: profile;
    box-sizing: border-box;
    width: 100%;
    min-height: 140px;
    padding: 0 var(--space-sm);
    ${dFlexCenter};
    gap: var(--space-xs);
    border-radius: var(--dimension-5);
    transition: all 0.5s;
    ${mobileMedia}{
        width: 100%;
    }
`;

export const content = styled.div`
    flex: 1 1 0;
    ${dFlexColumnCenter};
    gap: var(--space-sm);
`;

export const edit = styled.div`
    position: absolute;
    top: var(--space-lg);
    inset-inline-end: var(--space-lg);
    width: var(--dimension-8);
    height: var(--dimension-8);
    border-radius: 100px;
    background-color: var(--color-bg-surface-default, rgba(0, 0, 0, 0.05));
    cursor: pointer;
    ${BGImageCenter(editPencil, '16px 16px')};
`;

export const profileImage = styled.div<{ image?: string }>`
    width: var(--dimension-10);
    height: var(--dimension-10);
    border-radius: 9999px;
    background-color: var(--color-bg-surface-default, rgba(0, 0, 0, 0.05));
    ${p => BGImageCenter(p.image, 'cover')};
`;

export const userName = styled.div`
    align-self: stretch;
    text-align: center;
    font-size: var(--font-size-body);
    font-weight: 700;
    line-height: 22.4px;
    word-wrap: break-word;
    color: ${p => getColor(p.theme.isDarkMode)};
`;

export const roleLabel = styled(Label)`
    && {
        height: auto;
        background-color: var(--primitive-yellow-200);
        padding: var(--space-sm) var(--space-lg);
        gap: var(--space-sm);
        border-radius: 5px;
        font-size: var(--font-size-label);
        font-weight: 400;
        line-height: 16px;
    }
`;

export const roleIcon = styled.span<{ $icon?: string }>`
    width: var(--dimension-4);
    height: var(--dimension-4);
    flex-shrink: 0;
    ${p => BGImageCenter(p.$icon, '16px 16px')};
`;
